import React from 'react';
import markdownContent from '!!raw-loader!static/privacy.md';
import { Markdown } from 'Common';

export const AppPrivacyPage = () => {
  return (
    <Markdown className="app" scrollOffset={-10}>
      {markdownContent}
    </Markdown>
  );
};

export default AppPrivacyPage;
